export const IMPORT_STEPS = [
  { key: "upload", label: "Subir archivo" },
  { key: "map", label: "Mapear campos" },
  { key: "preview", label: "Vista previa" },
  { key: "confirm", label: "Confirmar" },
  { key: "results", label: "Resultados" },
];

export const IMPORT_STEP_KEYS = IMPORT_STEPS.map((step) => step.key);

export const IMPORT_MODES = [
  { value: "create_only", label: "Solo crear publicaciones nuevas" },
  { value: "update_by_stock", label: "Actualizar por código de inventario" },
  { value: "update_by_url", label: "Actualizar por URL externa" },
  { value: "update_by_plate", label: "Actualizar por placa interna" },
  { value: "create_and_update", label: "Crear y actualizar" },
];

export const IMPORT_MODE_VALUES = IMPORT_MODES.map((mode) => mode.value);

export const PUBLISH_MODES = [
  { value: "draft", label: "Importar como borrador" },
  { value: "needs_review", label: "Enviar a revisión" },
  { value: "active", label: "Publicar válidos de inmediato" },
];

export const PUBLISH_MODE_VALUES = PUBLISH_MODES.map((mode) => mode.value);

export const IMPORT_STATUS_LABELS = {
  uploaded: "Subido",
  mapping_required: "Mapeo requerido",
  preview_ready: "Listo para revisar",
  importing: "Importando…",
  completed: "Completado",
  completed_with_errors: "Completado con errores",
  failed: "Fallido",
  cancelled: "Cancelado",
};

export const IMPORT_STATUS_KEYS = Object.keys(IMPORT_STATUS_LABELS);

export const DUPLICATE_LABELS = {
  exact_stock_match: "Coincidencia exacta (stock)",
  exact_url_match: "Coincidencia exacta (URL)",
  exact_plate_match: "Coincidencia exacta (placa)",
  likely_duplicate: "Duplicado probable",
  possible_duplicate: "Posible duplicado",
  no_match: "Sin coincidencia",
};

export const DUPLICATE_STATUS_KEYS = Object.keys(DUPLICATE_LABELS);

export const ROW_ACTION_OPTIONS = [
  { value: "create", label: "Crear" },
  { value: "update", label: "Actualizar" },
  { value: "skip", label: "Omitir" },
  { value: "needs_review", label: "Revisión" },
];

export const ROW_ACTION_VALUES = ROW_ACTION_OPTIONS.map((option) => option.value);

export const TEMPLATE_FIELDS = [
  { key: "make", label: "Marca", required: true },
  { key: "model", label: "Modelo", required: true },
  { key: "version", label: "Versión", recommended: true },
  { key: "year", label: "Año", required: true },
  { key: "priceCop", label: "Precio (COP)", required: true },
  { key: "mileageKm", label: "Kilometraje", required: true },
  { key: "transmission", label: "Transmisión", required: true },
  { key: "fuel", label: "Combustible", required: true },
  { key: "bodyType", label: "Carrocería", required: true },
  { key: "color", label: "Color" },
  { key: "city", label: "Ciudad", required: true },
  { key: "neighborhood", label: "Barrio" },
  { key: "address", label: "Dirección" },
  { key: "description", label: "Descripción", recommended: true },
  { key: "financingAvailable", label: "Financiación", recommended: true },
  { key: "photoUrls", label: "URLs de fotos", recommended: true },
  { key: "engineSize", label: "Cilindraje" },
  { key: "doors", label: "Puertas" },
  { key: "internalPlate", label: "Placa interna" },
  { key: "internalVin", label: "VIN interno" },
  { key: "soatStatus", label: "SOAT" },
  { key: "tecnomecanicaStatus", label: "Tecnomecánica" },
  { key: "ownershipCount", label: "Propietarios" },
  { key: "accidentHistoryNote", label: "Nota accidentes" },
  { key: "dealerStockNumber", label: "Código inventario", recommended: true },
  { key: "externalListingUrl", label: "URL externa" },
  { key: "availabilityStatus", label: "Disponibilidad", recommended: true },
  { key: "lastConfirmedAt", label: "Última confirmación" },
];

export function formatImportStatus(status) {
  return IMPORT_STATUS_LABELS[status] || status || "—";
}

export function formatCop(value, locale = "es-CO") {
  if (value == null) return "—";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "COP",
    maximumFractionDigits: 0,
  }).format(value);
}

export function vehicleRowSummary(row) {
  const n = row.normalizedData;
  if (!n) return "—";
  return [n.year, n.make, n.model, n.version].filter(Boolean).join(" ");
}

export function importStepFromStatus(importRecord) {
  if (!importRecord) return "upload";
  if (["completed", "completed_with_errors", "failed"].includes(importRecord.status)) return "results";
  if (importRecord.status === "mapping_required") return "map";
  if (importRecord.status === "preview_ready") return "preview";
  if (importRecord.status === "importing") return "results";
  return "preview";
}
